import { Component, OnInit, AfterViewInit, ViewChild, OnChanges, ElementRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { ApplicantService } from '../services/applicant.service';
import { QuestionService } from '../services/question.service';
import { TosterService } from '../services/toster.service';
import { AllocationService } from 'src/app/services/allocation.service';
import { UtilityService } from '../services/utility.service';
@Component({
  selector: 'app-grand-total-report',
  templateUrl: './grand-total-report.component.html',
  styleUrls: ['./grand-total-report.component.css'],
})

export class GrandTotalReportComponent implements OnChanges, OnInit, AfterViewInit {
  @ViewChild('dataTable', { static: false }) table!: ElementRef;
  applicant_id: any;
  section: any = [];
  criteria: any;
  app_email: any;
  questions: any;
  subsection: any;
  answer: any;
  public model: any = {};
  modall: any = [];
  public modelscore: any = {};
  modallscore: any = [];
  udata: any;
  sec_done: any = [];
  private dataTable: any;
  section_no: any;
  allocated_id: any;
  assessor_data: any;
  subSections: any;
  assessment_data: any;
  all_scores: any = [];
  scoreOne: any;
  SubSecmodel: any = {};
  HighScrmodel: any = {};
  disableStatus: any = {};
  finalScore: any = [];
  tl: any;
  conper: any = [];
  highScore: any = 0;
  count: any = [];
  disableddata: any;
  version: any = '1';
  criteriaArray: any = [];
  arrSubSec: any = [];
  applicantData: any = [];
  private dataTableInitialized = false;
  counted_total: any = [];
  final_total: any = [];
  applicantS: any;
  sections_all: any;
  app_ids: any;
  highScoreArray: any = [];
  countArray: any;
  AllocationList: any;
  scores: any = {};
  applicantScores: any = {};
  sectorColor: any = {
    "Bakery": "#F1E4B3",
    "Beverage - Non-Alcoholic": "#E0D1F5",
    "Beverage -Alcoholic": "#D3E1F0",
    "Catering": "#E5E7A5",
    "Cereals and Cereal Products": "#F1F0C6",
    "Coffee": "#E5D8B0",
    "Confectionery": "#D8F8E8",
    "Dairy Products": "#F7D6B3",
    "Dried fruits, Nuts and Seeds": "#D4E6D3",
    "E-Commerce Online Grocery Marketplace": "#F3E5F5",
    "E-Commerce Ready to Cook meal": "#D1C8E3",
    "Fats and Oils": "#E7D3B9",
    "Food Additives": "#E8D2B0",
    "Food Ingredients": "#B5D0F0",
    "Food Packaging Materials": "#F5E0A9",
    "Food Testing Laboratories": "#D9E2C6",
    "Food Vendor": "#F0D4A2",
    "Fresh Produce Fruits & Vegetables": "#E1D6D0",
    "Functional Foods and Nutraceuticals": "#C7E8D9",
    "Health Supplements & Nutraceuticals": "#D8E1FF",
    "Innovation Management with Food Safety": "#F5C4A1",
    "Institutional Canteens/Food Courts/Cloud Kitchen": "#D1E8B4",
    "Joint Application": "#E6F2D0",
    "Meat and Meat Products": "#CFE2D6",
    "Others": "#F4D1D9",
    "Primary Production: Dairy": "#D4B7F0",
    "Quick Service Restaurants/Hotels": "#F1A6A6",
    "Ready To Cook": "#D6E1F3",
    "Ready To Eat": "#B9F0B1",
    "Salts, Spices, Soups, Sauces & Seasonings": "#F9E5B8",
    "Sweeteners": "#E1F2B8",
    "Tea": "#D9A1E6",
    "Wholesale/Retail/Warehousing/Transportation": "#D1F5A4",
  };

  headers: any = {
    'Criteria 1': {
      A: 'General Regulatory Requirements',
      B: 'Food Safety Practices',
    },
    'Criteria 11': {
      A: 'Statutory, Regulatory and Social Compliance',
      B: 'Laboratory Management',
      C: 'Leadership and Best Practices in Laboratory Initiatives',
    },
    'Criteria 2A for SMB': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Food counters and Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Display of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Eating facilities for Customers',
      '18': 'People, Competence & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Cont Imp, System, Tools and Techniques',
      '21': 'Recognition of People',
      '22': 'Canteen Management in Food Safety and Sustainability',
      '23': 'Food Takeaways/ Food Delivery',
      '24': 'Food Defence',
      '25': 'Food Loss - Food Waste',
      '26': 'Internal Checks/ Internal Audits'
    },
    'Criteria 2A Large': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Food counters and Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Display of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Eating facilities for Customers',
      '18': 'People, Competence & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Cont Imp, System, Tools and Techniques',
      '21': 'Recognition of People',
      '22': 'Canteen Management in Food Safety and Sustainability',
      '23': 'Food Takeaways/ Food Delivery',
      '24': 'Food Defence',
      '25': 'Food Loss - Food Waste',
      '26': 'Internal Checks/ Internal Audits'
    },
    'Criteria 2B for SMB': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Management of Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Delivery of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Delivery Containers , Personnel & Transport',
      '18': 'People, Competence, Culture & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Continual Improvement System, Tools and Techniques',
      '21': 'Recognition of People'
    },
    'Criteria 2B Large': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Management of Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Delivery of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Delivery Containers , Personnel & Transport',
      '18': 'People, Competence, Culture & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Continual Improvement System, Tools and Techniques',
      '21': 'Recognition of People'
    },
    'Criteria 2 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3 Large': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A1 Large': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A1 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A2 Large': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A2 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 4': {
      A: 'Social & Regulatory Requirement',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 5': [],
    'Criteria 7': {
      A: 'Self-Declaration',
      B4: 'Management of Partnerships',
    },
    'Criteria 9': {
      A: 'Statutory & Regulatory Requirements & Social Compliance',
      B1: 'Pre Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Good Manufacturing Practices (GMP)',
      D: 'Change Management Initiatives'
    },
  }
  
  coapp: any = [];
cocriteria: string = '';

  constructor(
    public allocation: AllocationService,
    private router: Router,
    private quest: QuestionService,
    private applicant: ApplicantService,
    private _Activatedroute: ActivatedRoute,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private toast: TosterService,
    public utilityService:UtilityService
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.udata = localStorage.getItem('userdata');
    this.udata = JSON.parse(this.udata);
    let email = this.udata.email;
    this.allocation.getAllAllocation().subscribe((item: any) => {
      this.AllocationList = item.result;
      this.AllocationList.sort((a: any, b: any) => {
        const sectorA = a.applicantData?.[0]?.sector?.toLowerCase() || '';
        const sectorB = b.applicantData?.[0]?.sector?.toLowerCase() || '';
        if (sectorA < sectorB) {
          return -1;
        }
        if (sectorA > sectorB) {
          return 1;
        }
        const nameCityA = `${a.applicantData?.[0]?.organizationName || ''}, ${a.applicantData?.[0]?.applicantCity || ''}`.toLowerCase();
        const nameCityB = `${b.applicantData?.[0]?.organizationName || ''}, ${b.applicantData?.[0]?.applicantCity || ''}`.toLowerCase();
        if (nameCityA < nameCityB) {
          return -1;
        }
        if (nameCityA > nameCityB) {
          return 1;
        }
        return 0;
      });
      for (const item of this.AllocationList) {
        const criteria = item['applicantData'][0]?.['criteria'];
        if (!this.applicantData.hasOwnProperty(criteria)) {
          this.applicantData[criteria] = [];
        }
        this.applicantData[criteria][item['applicant_id']] = [];
        this.applicantData[criteria][item['applicant_id']] = item;
      }
    });
    this.quest.viewCritSecs().subscribe((data: any) => {
      this.sections_all = data['criteriaSections'];
      this.criteriaArray = Object.keys(data.criteriaSections);
    });
    this.spinner.hide();
  }
  ngAfterViewInit() {
    this.initializeDataTable();
    this.dataTableInitialized = true;
  }
  ngOnChanges() {
    this.updateDataTable();
  }
  private initializeDataTable() {
    this.dataTable = $(this.table?.nativeElement).DataTable({
      dom: 'Bfrtip',
    });
  }
  private updateDataTable() {
    const dataTable = $(this.table.nativeElement).DataTable();
    dataTable.clear().destroy();
    this.initializeDataTable();
  }
  getCellStyle(value: number): { [key: string]: string } {
    if (value < 80) {
      return {
        'background-color': '#FFF1F1',
        'border-bottom': '2px solid red',
        'color': 'red',
        'font-weigth': '600'
      };
    } else {
      return {
        'background-color': '#F9F8F8',
        'border-bottom': '1px solid #ddd',
        'color': 'rgb(84 84 84);',
        'font-weigth': '600'
      };
    }
  }
  criteriaChange(criteria: any) {
    this.criteria = criteria;
    this.section_no = null
    this.section = this.sections_all[this.criteria];
    this.app_ids = Object.keys(this.applicantData[this.criteria] != null ? this.applicantData[this.criteria] : []);
    this.subSections = [];
    this.quest.getScores({ criteria: this.criteria }).subscribe((data: any) => {
      this.scores = data
    })
  }
  getscore(sec: any) {
    this.section_no = sec
    this.spinner.show();
    this.quest
      .getSubSection({
        criteria: this.criteria,
        section_no: sec,
      }).subscribe((itemQ: any) => { this.subSections = itemQ; this.spinner.hide(); })
    this.getQuestion(sec, this.app_ids);
  }
  getQuestion(sec: any, app_ids: any) {
    console.log(sec, app_ids);
    this.quest.getApplicantsScore({ applicants: app_ids, section: sec }).subscribe(
      (resp: any) => {
        this.applicantScores = resp.conscores
      }
    )
  }
  checkValue(secno: string, i: any): boolean {
    var test = false;
    var data = this.all_scores;
    data.forEach((item: any) => {
      if (item[0]?.applicable[0][secno]) {
        if (i == 0 || i == '0' || i == '' || i == 0.0) {
          test = true;
          this.updateValues(secno);
          this.sec_done.push(secno);
        }
      }
    });
    this.sec_done.push(secno);
    return test;
  }
  updateValues(ssno: any) {
    this.conper = 0;
    this.highScore = 0;
    this.count = 0;
    this.HighScrmodel[ssno] = 0;
    this.SubSecmodel[ssno] = 0;
    if (true) {
      this.arrSubSec.push(ssno)
    }
    else {
      var index = this.arrSubSec.findIndex(function (o: any) {
        return o === ssno;
      });
      if (index !== -1) this.arrSubSec.splice(index, 1);
    }
    this.finalScore.map((itemm: any) => {
      if (itemm.subsectionno === ssno) {
        itemm.score = 0;
        itemm.highestscore = 0;
        itemm.consensusscore = 0;
        itemm.chkStatus = true;
      }
    })
    for (var el in this.HighScrmodel) {
      if (this.HighScrmodel.hasOwnProperty(el)) {
        this.highScore += parseFloat(this.HighScrmodel[el]);
        this.count +=
          (parseFloat(
            this.SubSecmodel[el] == 'NA'
              ? 0
              : this.SubSecmodel[el] == ''
                ? 0
                : this.SubSecmodel[el]
          ) /
            100) *
          parseFloat(this.HighScrmodel[el]);
      }
    }

  }
  compareDates(dt: any, createdAt: any): boolean | undefined {
    let currentDate = new Date(createdAt);
    let applicantDate = new Date(dt);
    let threeYearsAgo = new Date(currentDate.getFullYear() - 3, currentDate.getMonth(), currentDate.getDate());
    if (
      (applicantDate.getTime() >= threeYearsAgo.getTime() && applicantDate.getTime() <= currentDate.getTime()) ||
      applicantDate.getTime() > currentDate.getTime()
    ) {
      return true;
    }
    return false;
  }
  getSectorColor(sector: string): string {
    return this.sectorColor[sector] || '#EAEAEA';
  }

  getHeaderValue(criteria: string, item: any): string {
    return this.headers[criteria] && this.headers[criteria][item] || item;
  }

  loadCoAppScore(allocation_id: string, applicant_id: string) {
    this.spinner.show('sp2');
    this.quest
      .getcoapplicant({
        allocation_id: allocation_id,
        applicant_id: applicant_id
      }).subscribe({
        next: (res: any) => {
          this.coapp = res.data
          this.spinner.hide('sp2');
        },
        error: (err: any) => {
          this.spinner.hide('sp2');
        }
      })
  }

  testingModule(entity:string, operationForm: string, createdAt: string) {
  console.log(entity, operationForm, createdAt);

  }
}
